import type { Tag } from '~/composables/types/tag'

export const useEventTagLink = () => {
  const { t } = useI18n()
  const localePath = useLocalePath()

  const teamEventSlugPrefix = computed(() =>
    t('eventListPage.teamEventSlugPrefix')
  )

  const getEventTagLink = (tag?: Tag | null) => {
    if (!tag?.slug) {
      return ''
    }
    if (tag.slug.startsWith(teamEventSlugPrefix.value)) {
      return localePath(
        `/teamevent/${tag.slug.replace(`${teamEventSlugPrefix.value}-`, '')}`
      )
    }
    return localePath(`/t/${tag.slug}`)
  }

  return { getEventTagLink }
}
